import {
  CampaignBodyGingerTeaCategoryTreeEnum,
  CampaignBodyGingerTeaRelevantObjectClassesEnum,
} from "@vviinn/user-managment-client-ts";
import { valuesToSettings } from "../../details/helpers";

const gingerTeaRelevantObjectClassesEnum: CampaignBodyGingerTeaRelevantObjectClassesEnum[] =
  ["manual", "default"]; //TODO add "castom" and "category_tree" in scope of 37687

const gingerTeaCategoryTreeEnum: CampaignBodyGingerTeaCategoryTreeEnum[] = [
  "google_product_category",
  "product_type",
];

export const gingerTeaSelectableSettings = {
  gingerTeaRelevantObjectClasses: valuesToSettings(
    gingerTeaRelevantObjectClassesEnum,
  ),
  gingerTeaCategoryTree: valuesToSettings(gingerTeaCategoryTreeEnum),
};
